//  Checks if an object is not empty.
import { SSMClient } from '@aws-sdk/client-ssm';

export const isObjectHasKeys = (obj: Record<string, unknown> | SSMClient = {}): boolean => Object.keys(obj).length > 0;
